export default [
    {
        path: '/warehouse/transfer',
        name: 'transfer',
        props: true,
        component: () => import('@/views/warehouse/transfer/index.vue'),
        meta: {
            pageTitle: 'Transfer',
            breadcrumb: [
                {
                text: 'Transfer',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/transfer/add',
        name: 'create-transfer',
        component: () => import('@/views/warehouse/transfer/create.vue'),
        meta: {
            pageTitle: 'Create Transfer',
            breadcrumb: [
                {
                text: 'Transfer',
                to: { name: 'transfer' },
                },
                {
                text: 'Create Transfer',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/transfer/:id',
        name: 'detail-transfer',
        props: true,
        component: () => import('@/views/warehouse/transfer/detail.vue'),
        meta: {
            pageTitle: 'Detail Transfer',
            breadcrumb: [
                {
                text: 'Transfer',
                to: { name: 'transfer' },
                },
                {
                text: 'Detail Transfer',
                active: true,
                },
            ],
        },
    },
]